import { useLocales } from '@hako/core'
import { useState } from 'react'
import Cookies from 'js-cookie'
import { router } from 'next/client'

const cookieName = 'evnia-show-available-language-bar'

export const AvailableLanguageNotice = () => {
    const { preferred, current } = useLocales()
    const [visible, setIsVisible] = useState(
        Cookies.get(cookieName) !== undefined ? false : true
    )

    if (
        !preferred ||
        !visible ||
        !current ||
        preferred.code === current?.code
    ) {
        return null
    }

    const dismiss = () => {
        Cookies.set(cookieName, false, { expires: 14 })
        setIsVisible(false)
    }

    const changeLanguage = () => {
        router.push('/', undefined, { locale: preferred.code })
    }

    return (
        <div className="section section--gray grid grid-column-start-1 grid-column-end-13 grid-column-tablet-start-1 grid-column-tablet-end-9 grid-column-mobile-start-1 grid-column-mobile-end-5 u-padding-xsmall js-language-bar">
            <div className="grid-container u-flex-row u-justify-content-space-between u-align-items-center column-gap-small">
                <div className="u-flex-row u-align-items-center">
                    <p className="paragraph paragraph--small u-margin-none">
                        This page is also available in {preferred.name}
                    </p>
                    <button
                        className="btn btn--small btn--outline u-margin-left-small u-margin-right-small"
                        onClick={changeLanguage}
                    >
                        Change
                    </button>
                </div>
                <button
                    className="icon icon--normal u-cursor-pointer"
                    onClick={dismiss}
                >
                    <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M30.5002 9.51659C30.1888 9.20451 29.7661 9.02912 29.3252 9.02912C28.8843 9.02912 28.4616 9.20451 28.1502 9.51659L20.0002 17.6499L11.8502 9.49993C11.5388 9.18784 11.1161 9.01245 10.6752 9.01245C10.2343 9.01245 9.81158 9.18784 9.5002 9.49993C8.8502 10.1499 8.8502 11.1999 9.5002 11.8499L17.6502 19.9999L9.5002 28.1499C8.8502 28.7999 8.8502 29.8499 9.5002 30.4999C10.1502 31.1499 11.2002 31.1499 11.8502 30.4999L20.0002 22.3499L28.1502 30.4999C28.8002 31.1499 29.8502 31.1499 30.5002 30.4999C31.1502 29.8499 31.1502 28.7999 30.5002 28.1499L22.3502 19.9999L30.5002 11.8499C31.1335 11.2166 31.1335 10.1499 30.5002 9.51659Z" />
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default AvailableLanguageNotice
